import { biggerPhone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledSection = styled.section`
  &:not(:first-child) {
    overflow: hidden;
    padding-top: 120px;
    ${biggerPhone(css`
      padding-top: 80px;
    `)};
  }
`
